import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, MessageSquare } from 'lucide-react';

const SMSTermsPage = () => {
  return (
    <div className="min-h-screen bg-[#0a1628] py-8" data-testid="sms-terms-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[#a8b8d0] hover:text-white mb-6 transition-colors"
          >
            <ArrowLeft size={20} />
            Back to Home
          </Link>
          <div className="flex items-center gap-3 mb-4">
            <div className="bg-[#ff6b35]/20 p-3 rounded-full">
              <MessageSquare className="text-[#ff6b35]" size={28} />
            </div>
            <h1 className="text-3xl sm:text-4xl font-bold text-white font-['Exo_2']">
              Terms of Service
            </h1>
          </div>
          <p className="text-[#a8b8d0]">
            Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>
        </div>

        {/* Content */}
        <div className="bg-[#132238] rounded-xl p-6 sm:p-8 border border-[#1a2d47]">
          <div className="prose prose-invert max-w-none text-[#a8b8d0] space-y-6">
            
            <section>
              <h2 className="text-xl font-bold text-white mb-3">Opt-In and Message Types</h2>
              <p>
                When you opt-in to the service, we will send you a message to confirm your signup. Depending on your selection, you may receive marketing and non-marketing messages which include offers, news, and updates. Message frequency varies. Message and data rates may apply. Consent to receive marketing messages is not a condition of any purchase.
              </p>
              <p className="mt-3">
                Text "<span className="text-white font-semibold">HELP</span>" for help. Text "<span className="text-white font-semibold">STOP</span>" to cancel.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-3">How to Unsubscribe</h2>
              <p>
                You can cancel this service at any time. Just text "<span className="text-white font-semibold">STOP</span>" to the number that texted you. After you send the message "STOP" to us, we will send you a reply message to confirm that you have been unsubscribed. After this, you will no longer receive messages from us.
              </p>
              <p className="mt-3">
                If you want to join again, just sign up as you did the first time and we will start sending messages to you again.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-3">Getting Help</h2>
              <p>
                If at any time you forget what keywords are supported, just text "<span className="text-white font-semibold">HELP</span>" to the number that texted you. After you send the message "HELP" to us, we will respond with instructions on how to use our service as well as how to unsubscribe.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-3">Carrier Liability</h2>
              <p>
                Carriers are not liable for delayed or undelivered messages.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-3">Questions</h2>
              <p>
                For all questions about the messages sent to you by us, you can send an email to{' '}
                <a href="mailto:info@wehaveyourcar.com" className="text-[#ff6b35] hover:underline">
                  info@wehaveyourcar.com
                </a>.
              </p>
              <p className="mt-3">
                If you have any questions regarding privacy, please read our{' '}
                <Link to="/privacy-policy" className="text-[#ff6b35] hover:underline">
                  Privacy Policy
                </Link>.
              </p>
            </section>

            {/* Contact Information */}
            <section className="border-t border-[#1a2d47] pt-6 mt-6">
              <h2 className="text-xl font-bold text-white mb-3">Contact Information</h2>
              <div className="space-y-2">
                <p><span className="text-white">Business:</span> AKO GLOBAL LLC dba We Have Your Car</p>
                <p><span className="text-white">Address:</span> 8203 Bluff Springs Rd, Unit 4, Austin, TX 78744</p>
                <p><span className="text-white">Phone:</span> <a href="tel:5126660016" className="text-[#ff6b35] hover:underline">(512) 666-0016</a></p>
                <p><span className="text-white">Email:</span> <a href="mailto:info@wehaveyourcar.com" className="text-[#ff6b35] hover:underline">info@wehaveyourcar.com</a></p>
              </div>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default SMSTermsPage;
